import React from 'react';
import { Link } from 'react-router-dom'
import sidebar from './../../assets/images/header.jpg'
import logo from './../../assets/images/logo.png'
import { connect } from 'react-redux';
import { sidebarExpand } from '../../actions'

const Sidebar = (props) => {
    const { expandMode } = props;
    const expandeMenu = () => {
        props.dispatch(sidebarExpand(false));
    };
    const handleCloseMenu = ()=>{
        props.dispatch(sidebarExpand(false));
    }
    return (
        <aside className={`sidebar ${expandMode ? "open" : ""}`}>
            <div className="sidebar-wrapper">
                <div className="top-sidebar">
                    <img src={sidebar} alt="#" />
                    <img src={logo} alt="logo" className="sidebar-logo" />
                </div>
                <ul className="">
                    <li onClick={expandeMenu}>
                        <Link to="/">صفحه اصلی</Link>
                    </li>
                    <li onClick={expandeMenu}>
                        <Link to="/ussd">USSD Code</Link>
                    </li>
                    <li onClick={expandeMenu}>
                        <Link to="/about">درباره ما</Link>
                    </li>
                    <li onClick={expandeMenu}>
                        <Link to="/setting">تنظیمات</Link>
                    </li>
                </ul>
            </div>
            <div className="sidebar-overlay" onClick={handleCloseMenu}></div>
        </aside>
    )
}
const mapStateToProps = state => {
    return {
        expandMode: state.expandMode
    }
}

export default connect(mapStateToProps)(Sidebar);
//export default Sidebar;